import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './store';

import Login from '@/csmworkflow/js/views/Login';
import Report from '@/csmworkflow/js/views/Report';
import MyWeek from '@/csmworkflow/js/views/MyWeek';
import Project from '@/csmworkflow/js/views/Project';
import Register from '@/csmworkflow/js/views/Register';
import AuditLog from '@/csmworkflow/js/views/AuditLog';
import Calendar from '@/csmworkflow/js/views/Calendar';
import Dashboard from '@/csmworkflow/js/views/Dashboard';
import DeliverableTemplates from '@/csmworkflow/js/views/DeliverableTemplateDashboard';
import MyProjects from '@/csmworkflow/js/views/MyProjects';
import GlobalAlert from '@/csmworkflow/js/views/GlobalAlert';
import GlobalSearch from '@/csmworkflow/js/views/GlobalSearch';
import PasswordReset from '@/csmworkflow/js/views/PasswordReset';
import ForgotPassword from '@/csmworkflow/js/views/ForgotPassword';
import UserGlobalAlert from '@/csmworkflow/js/views/UserGlobalAlert';
import PermissionManager from '@/csmworkflow/js/views/PermissionManager';
import ProjectDeliverable from '@/csmworkflow/js/views/ProjectDeliverable';
import AddProjectDeliverable from '@/csmworkflow/js/views/AddProjectDeliverable';
import MediaCallPage from '@/csmworkflow/js/views/MediaCallPage';
import DashboardMediaCalls from '@/csmworkflow/js/views/DashboardMediaCalls';
import SocialMedia from '@/csmworkflow/js/views/SocialMedia';
import SocialMediaSchedule from '@/csmworkflow/js/views/SocialMediaSchedule';
import SocialMediaGrouped from '@/csmworkflow/js/views/SocialMediaGrouped';



Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: Login,
            meta: {
                title: 'Login'
            }
        },
        {
            path: '/forgot-password',
            name: 'forgotPassword',
            component: ForgotPassword,
            meta: {
                title: 'Forgot Password'
            }
        },
        {
            path: '/password-reset/:token(.*)',
            name: 'passwordReset',
            component: PasswordReset,
            meta: {
                title: 'Password Reset'
            }
        },
        {
            path: '/all-deliverables',
            name: 'dashboard',
            component: Dashboard,
            alias: '/deliverable/:deliverableId/:slug',
            meta: {
                requiresAuth: true,
                title: 'All Deliverables'
            }
        },
        {
            path: '/all-deliverables/new/:deliverableId/',
            name: 'dashboardNewDeliverable',
            component: Dashboard,
            meta: {
                requiresAuth: true,
                title: 'New Deliverable (All Deliverables)'
            }
        },
        {
            path: '/all-deliverables/:deliverableId/:slug?',
            name: 'dashboardDeliverableDetail',
            component: Dashboard,
            meta: {
                requiresAuth: true,
                title: 'All Deliverable'
            }
        },
        {
            path: '/deliverable-templates',
            name: 'deliverable-templates',
            component: DeliverableTemplates,
            alias: '/deliverable-templates/:deliverableTemplateId/:slug',
            meta: {
                requiresAuth: true,
                title: 'Deliverable Templates'
            }
        },
        {
            path: '/deliverable-templates/new/:deliverableTemplateId/',
            name: 'deliverableTemplateNew',
            component: DeliverableTemplates,
            meta: {
                requiresAuth: true,
                title: 'New Deliverable Template'
            },
        },
        {
            path: '/deliverable-templates/:deliverableTemplateId/:slug?',
            name: 'deliverableTemplateDetail',
            component: DeliverableTemplates,
            meta: {
                requiresAuth: true,
                title: 'Deliverable Templates Detail'
            }
        },
        {
            path: '/media-calls',
            name: 'mediaCallPage',
            component: MediaCallPage,
            meta: {
                requiresAuth: true,
                title: ' All Media Calls'
            }
        },
        {
            path: '/media-calls/new/:deliverableId/',
            name: 'mediaCallPageNewMediaCall',
            component: MediaCallPage,
            meta: {
                requiresAuth: true,
                title: 'New Media Call (All Media Calls)'
            }
        },
        {
            path: '/media-calls/:deliverableId/:slug?',
            name: 'mediaCallDetail',
            component: MediaCallPage,
            meta: {
                requiresAuth: true,
                title: 'All Media Call'
            }
        },
        {
            path: '/calendar',
            name: 'calendar',
            component: Calendar,
            meta: {
                requiresAuth: true,
                title: 'Calender'
            }
        },
        {
            path: '/calendar/:deliverableId/:slug?',
            name: 'calendarDeliverableDetail',
            component: Calendar,
            meta: {
                requiresAuth: true,
                title: 'Calendar Deliverable'
            }
        },
        {
            path: '/global-search',
            redirect: '/global-search/all'
        },
        {
            path: '/global-search/all',
            name: 'globalSearchAll',
            component: GlobalSearch,
            meta: {
                requiresAuth: true,
                title: 'Global Search All',
                tabType: 'all'
            }
        },
        {
            path: '/global-search/departments',
            name: 'globalSearchDepartments',
            component: GlobalSearch,
            meta: {
                requiresAuth: true,
                title: 'Global Search Departments',
                tabType: 'departments'
            }
        },
        {
            path: '/global-search/contacts',
            name: 'globalSearchContacts',
            component: GlobalSearch,
            meta: {
                requiresAuth: true,
                title: 'Global Search Contacts',
                tabType: 'contacts'
            }
        },
        {
            path: '/global-search/users',
            name: 'globalSearchUsers',
            component: GlobalSearch,
            meta: {
                requiresAuth: true,
                title: 'Global Search Users',
                tabType: 'coordinators'
            }
        },
        {
            path: '/global-search/tags',
            name: 'globalSearchTags',
            component: GlobalSearch,
            meta: {
                requiresAuth: true,
                title: 'Global Search Tags',
                tabType: 'tags'
            }
        },
        {
            path: '/audit-log',
            name: 'auditLog',
            component: AuditLog,
            meta: {
                requiresAuth: true,
                title: 'Audit Log'
            }
        },
        {
            path: '/global-alert',
            name: 'globalAlert',
            component: GlobalAlert,
            meta: {
                requiresAuth: true,
                title: 'Global Alert'
            }
        },
        {
            path: '/global-alert/new/:alertId/',
            name: 'globalAlertNew',
            component: GlobalAlert,
            meta: {
                requiresAuth: true,
                title: 'New Global Alert'
            }
        },
        {
            path: '/global-alert/:alertId/:slug?',
            name: 'globalAlertDetail',
            component: GlobalAlert,
            meta: {
                requiresAuth: true,
                title: 'Global Alert Detail'
            }
        },
        {
            path: '/global-alert/:alertId/status/:slug?',
            name: 'globalAlertStatus',
            component: GlobalAlert,
            meta: {
                requiresAuth: true,
                title: 'Alert Status Log'
            }
        },
        {
            path: '/user-global-alert',
            name: 'userGlobalAlert',
            component: UserGlobalAlert,
            meta: {
                requiresAuth: true,
                title: 'User Global Alert'
            }
        },
        {
            path: '/report',
            name: 'report',
            component: Report,
            meta: {
                requiresAuth: true,
                title: 'Reports'
            }
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
             meta: {
                title: 'Login'
            }
        },
        {
            path: '/my-week',
            name: 'myWeek',
            component: MyWeek,
            meta: {
                requiresAuth: true,
                title: 'My Week'
            }
        },
        {
            path: '/my-week/new/:deliverableId/',
            name: 'myWeekNewDeliverable',
            component: MyWeek,
            meta: {
                requiresAuth: true,
                title: 'New Deliverable (My Week)'
            }
        },
        {
            path: '/my-week/:deliverableId/:slug?',
            name: 'myWeekDeliverableDetail',
            component: MyWeek,
            meta: {
                requiresAuth: true,
                title: 'My Week'
            }
        },
        {
            path: '/my-projects',
            name: 'myProjects',
            component: MyProjects,
            meta: {
                requiresAuth: true,
                title: 'My Projects'
            }
        },
        {
            path: '/my-projects/:projectId/addDeliverable',
            name: 'addMyProjectDeliverable',
            component: AddProjectDeliverable,
            meta: {
                requiresAuth: true,
                title: 'My Projects Deliverable'
            }
        },
        {
            path: '/my-projects/:projectId',
            name: 'myProjectDeliverable',
            component: ProjectDeliverable,
            meta: {
                requiresAuth: true,
                title: 'My Project'
            }
        },
        {
            path: '/project',
            name: 'project',
            component: Project,
            meta: {
                requiresAuth: true,
                title: 'All Projects'
            }
        },
        {
            path: '/project/:projectId/addDeliverable',
            name: 'addProjectDeliverable',
            component: AddProjectDeliverable,
            meta: {
                requiresAuth: true,
                title: 'All Projects Deliverable'
            }
        },
        {
            path: '/project/:projectId',
            name: 'projectDeliverable',
            component: ProjectDeliverable,
            meta: {
                requiresAuth: true,
                title: 'All Project'
            }
        },
        {
            path: '/permission-manager',
            name: 'permissionManager',
            component: PermissionManager,
            meta: {
                requiresAuth: true,
                title: 'Permission Manager'
            }
        },
        {
            path: '/register',
            name: 'register',
            component: Register,
            meta: {
                title: 'Register'
            }
        },
        {
            path: '/logout',
            name: 'logout',
            meta: {
                title: 'Logout'
            }
        },
        {
            path: '/dashboard/media-calls',
            name: 'dashboardMediaCalls',
            component: DashboardMediaCalls,
            meta: {
                requiresAuth: false,
                title: 'Media Call Dashboard'
            }
        },
        {
            path: '/social-media-calendar',
            name: 'socialMedia',
            component: SocialMediaGrouped,
            props: true,
            meta: {
                requiresAuth: true,
                title: 'Social Media Calendar',
                viewType: 'calendar'
            }
        },
        {
            path: '/social-media-calendar/:deliverableId/:slug?',
            name: 'socialMediaCalendarDetail',
            component: SocialMediaGrouped,
            meta: {
                requiresAuth: true,
                title: 'Social Media Calendar Detail',
                viewType: 'calendar'
            }
        },
        {
            path: '/social-media-grouped',
            redirect: '/social-media-calendar'
        },
        {
            path: '/social-media-grouped/:deliverableId/:slug?',
            redirect: to => {
                return `/social-media-calendar/${to.params.deliverableId}${to.params.slug ? '/' + to.params.slug : ''}`
            }
        },
        {
            path: '/social-media-schedule',
            name: 'socialMediaSchedule',
            component: SocialMediaSchedule,
            props: true,
            meta: {
                requiresAuth: true,
                title: 'Social Media Schedule',
                viewType: 'schedule'
            }
        },
        {
            path: '/social-media-schedule/:deliverableId/:slug?',
            name: 'socialMediaScheduleDetail',
            component: SocialMediaSchedule,
            meta: {
                requiresAuth: true,
                title: 'Social Media Schedule Detail',
                viewType: 'schedule'
            }
        }
    ]
});

router.beforeEach(async (to, from, next) => {

	// wait for components to trigger isDirty.
	  const waitForComponents = new Promise(resolve => {
	    const checkReady = setInterval(() => {
	      if (!store.getters.isDirty) {
	        clearInterval(checkReady);
	        resolve(true);
	      }
	    }, 250); // Check every 100ms
	  });
	  await waitForComponents;

	if (store.getters.isDirty) {
	  // Wait for `isReady` to become true
      let loopCounter = 0;
	  const waitForReady = new Promise(resolve => {
	    const checkReady = setInterval(() => {
	      if (!store.getters.isDirty) {
	        clearInterval(checkReady);
	        resolve(true);
	      }
	      loopCounter++;
	      if (loopCounter > 100) {
	      	// navigate away after 10 seconds of waiting for the server.
	      	clearInterval(checkReady);
	      	resolve(true);
	      }
	    }, 100); // Check every 100ms
	  });
	  await waitForReady;
	}
    const globalSearchRoutes = ['globalSearchAll', 'globalSearchDepartments', 'globalSearchContacts', 'globalSearchUsers', 'globalSearchTags'];
    if (globalSearchRoutes.includes(from.name) && !globalSearchRoutes.includes(to.name)) {
        const fromTabType = from.meta.tabType;
        if (fromTabType && store.getters.globalSearchFilter) {
            store.commit('setGlobalSearchTabFilter', {
                tabType: fromTabType,
                filter: store.getters.globalSearchFilter
            });
        }
    }
    if (!globalSearchRoutes.includes(from.name) && globalSearchRoutes.includes(to.name)) {
        const toTabType = to.meta.tabType;
        if (toTabType) {
            store.commit('restoreGlobalSearchTabFilter', toTabType);
        }
    }
    const DEFAULT_PAGE_ROUTES = ['project', 'myProjects', 'mediaCallPage', 'dashboard', 'myWeek', 'globalAlert', 'globalSearchAll', 'globalSearchDepartments', 'globalSearchContacts', 'globalSearchUsers', 'globalSearchTags', 'socialMedia'];

        if (
            DEFAULT_PAGE_ROUTES.includes(to.name) &&
            !to.query.page
        ) {
            const nextConfig = {
                name: to.name,
                query: { ...to.query, page: 1 }
            };
            if (Object.keys(to.params).length > 0) {
                nextConfig.params = to.params;
            }
            return next(nextConfig);
    }
    if ( to.name == "dashboardMediaCalls"){
        next()
    }else{
        if(store.getters.isLoggedIn) {
            store.dispatch('fetchUserPermissions');
            store.dispatch('fetchUserAlerts');
            // store.dispatch('fetchAlerts');
            const globalAlertRoutes = ['globalAlert', 'globalAlertDetail', 'globalAlertStatus', 'globalAlertNew'];
            const globalAlertDetailRoutes = ['globalAlertDetail', 'globalAlertStatus', 'globalAlertNew'];
            const page = Number(to.query.page) || 1;
            if (globalAlertRoutes.includes(to.name)) {
                const isDirectAccess = !from.name || !globalAlertRoutes.includes(from.name);
                if (to.name === 'globalAlert' || (globalAlertDetailRoutes.includes(to.name) && isDirectAccess)) {
                    store.dispatch('fetchAlerts', page);
                }
            } else {
                store.dispatch('fetchAlerts');
            }
            store.dispatch('fetchUserProjectsCount');
        }
        if (to.matched.some(record => record.meta.requiresAuth)) {
            // this route requires auth, check if logged in
            // if not, redirect to login page.
            if (!store.getters.authToken) {
                next({ name: 'login', query: { redirect: to.fullPath } })
            } else {
                next() // go to wherever I'm going
            }
        } else {
            if(store.getters.isLoggedIn) {
                next({name: 'myWeek'})
                //next()
            }
            next() // does not require auth, make sure to always call next()!
        }
    }

});
router.afterEach(async () => {
    Vue.nextTick(() => {
        const current = router.currentRoute;
        let title = current.meta.title || 'Workflow';
        const page = Number(current.query.page);
        if (!Number.isNaN(page) && page >= 1) {
            title = `${title} - Page ${page}`;
        }
        document.title = title;
    });
});

export default router;
